import React from 'react';
import styles from './LoadingSpinner.module.css';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
  overlay?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'medium', message, overlay = false }) => {
  const sizeClass = styles[size] || styles.medium;

  const spinner = (
    <div className={styles.spinnerContainer} data-testid="loading-spinner">
      <div className={`${styles.spinner} ${sizeClass}`}></div>
      {message && <p className={styles.message}>{message}</p>}
    </div>
  );

  if (overlay) {
    return <div className={styles.overlay}>{spinner}</div>;
  }

  return spinner;
};

export default LoadingSpinner;
